var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"asd"},[_vm._v(" "+_vm._s(_vm.$pick({a: 2, b: 3, c: 4}, 'a', 'c'))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }